var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPetServices(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 102,
    height: 102,
    viewBox: "0 0 102 102",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_dii_4857_1707)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M54.2851 0.378413C53.1151 0.288413 51.9351 0.248413 50.7451 0.248413C23.1351 0.248413 0.745136 22.6384 0.745136 50.2484C0.745136 77.8584 23.1351 100.248 50.7451 100.248C72.3051 100.248 90.6751 86.5984 97.6951 67.4784C99.6651 62.1084 100.745 56.2984 100.745 50.2484C100.745 23.8284 80.2451 2.18841 54.2851 0.378413ZM93.8851 58.8784C92.8551 55.8484 90.9051 50.8584 90.3251 49.4684C89.9151 48.4984 88.4551 46.4784 88.3051 45.8584C88.0551 44.7784 88.1851 43.0784 87.9151 41.7284C86.9651 36.9484 84.3651 31.8084 80.8551 28.6184L80.2251 28.8284L76.8351 39.8284C72.5651 40.6284 67.5751 41.2384 64.8651 45.3384C63.2151 47.8384 63.6351 50.6184 60.4351 52.1284C58.1251 53.2184 56.6951 52.0384 57.1051 55.6584C57.4351 58.5084 59.5851 61.1484 61.2251 63.2584C64.3751 67.3284 73.0451 63.7284 70.9451 73.5284C69.7351 79.1984 65.5951 84.8584 66.6551 91.2584C61.7151 93.1784 56.3551 94.2384 50.7451 94.2384C43.6651 94.2384 36.9751 92.5484 31.0451 89.5684C35.6051 81.0784 32.1751 70.5484 34.9551 61.7684C38.1251 51.7884 44.7251 58.3184 50.4251 54.6984C53.8051 52.5484 57.5351 46.8184 56.6651 42.5084C56.3451 41.7284 47.8251 40.2584 46.3651 39.7584C42.1051 38.2984 43.0551 36.8984 41.0851 33.6284C39.1651 30.4584 35.5651 28.9984 32.1951 28.3284L33.0751 20.4584C30.9951 22.1484 27.9551 24.8684 27.9951 27.8684C26.8951 24.7584 27.6051 21.2884 27.6551 18.0684C26.8651 17.1284 20.7551 26.9384 20.3251 27.6484C18.9251 30.0284 12.8951 40.9684 12.9451 43.0384C13.0451 47.4084 23.4151 56.8384 27.3851 50.1784C29.6751 46.3384 28.4651 40.8484 27.7451 36.7184C27.7051 36.4684 27.4451 35.9384 27.8651 35.9884C29.5251 39.5984 30.7651 43.1684 30.2951 47.2784C29.5451 53.8384 24.0951 56.3184 18.7651 53.1584C16.9051 52.0484 15.5451 50.2384 13.8651 48.9084C12.3651 53.0984 10.2251 56.9284 8.00514 60.7084C7.18514 57.3484 6.73514 53.8484 6.73514 50.2384C6.73514 42.7684 8.60514 35.7384 11.9051 29.5684C19.3251 15.7084 33.9551 6.24841 50.7451 6.24841C75.0051 6.24841 94.7451 25.9884 94.7451 50.2484C94.7451 53.1984 94.4351 56.0884 93.8851 58.8784Z",
    fill: "#FF4D6A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.4251 30.0284V38.8684L75.5351 38.3384L76.4551 34.0284C76.1051 33.5184 72.7051 29.7884 72.4251 30.0284Z",
    fill: "#FF4D6A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.6951 82.2684C53.6651 79.7984 53.3851 75.5984 49.0751 76.2384C45.9951 76.6884 45.7051 79.7384 44.1551 81.7884C42.3851 84.1284 38.8951 85.4684 40.9451 89.4984C43.0351 93.5884 46.8251 90.1884 49.4651 90.0284C52.3551 89.8584 55.7951 93.3284 58.3651 90.1184C61.2651 86.5084 57.4151 84.3584 55.6951 82.2584V82.2684Z",
    fill: "#FF4D6A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.2351 74.4384C50.3451 75.3884 49.2951 64.0884 44.5551 64.9784C40.8651 65.6684 41.7151 73.7784 45.2351 74.4384Z",
    fill: "#FF4D6A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.5951 64.9884C50.2251 65.8184 49.7451 74.7284 53.9951 74.5184C58.4351 74.2984 58.5751 63.7684 53.5951 64.9884Z",
    fill: "#FF4D6A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.2351 81.1084C63.3951 81.2784 65.1051 71.5984 59.7051 72.8784C56.6651 73.5984 55.3751 80.9484 59.2351 81.1084Z",
    fill: "#FF4D6A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.2351 80.8484C44.7151 78.9084 41.9951 71.9384 38.2151 72.8784C34.6551 73.7684 36.9651 82.2384 41.2351 80.8484Z",
    fill: "#FF4D6A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dii_4857_1707",
    x: -5.96046e-8,
    y: 0.0000344813,
    width: 101.49,
    height: 102.32,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.496757
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.372568
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "screen",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4857_1707"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_4857_1707",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.07148
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.86284
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "multiply",
    in2: "shape",
    result: "effect2_innerShadow_4857_1707"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.07796
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.24189
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "soft-light",
    in2: "effect2_innerShadow_4857_1707",
    result: "effect3_innerShadow_4857_1707"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPetServices);
export default __webpack_public_path__ + "static/media/PetServices.39f767484a0f06d895987be5be851269.svg";
export { ForwardRef as ReactComponent };